import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { FaWeight } from 'react-icons/fa'
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaEye } from "react-icons/fa";
import { FaIdCard, FaAddressCard, FaTimes, FaEdit, FaSave } from 'react-icons/fa';
import { Url_For_View_Document } from '../../../config/config';

const schema = z.object({
  id: z.string().min(1, "ID is required"),
  seller_id: z.string().min(1, "Seller ID is required"),
  waybill: z.string().min(1, "Waybill is required"),
  initial_weight: z.string().min(1, "Initial Weight is required"),
  dimension: z.string().min(1, "Dimension is required"),
  product_des: z.string().min(1, "Product Description is required"),
  sku: z.string().min(1, "SKU is required"),
  date: z.string().min(1, "Date is required"),
  reversed_weight: z.string().min(1, "Reversed Weight is required"),
  price: z.string().min(1, "Price is required"),
  status: z.string().min(1, "Status is required"),
  timestamp: z.string().min(1, "Timestamp is required"),
});

const ViewWeightDisputes = ({ isopen, onClose, allWeightDisputes }) => {
  const { isDarkMode } = useMyContext();
  const [imageUrls, setImageUrls] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: zodResolver(schema),
  });


  // useEffect(() => {
  //   if (allWeightDisputes) {
  //     reset({
  //       id: allWeightDisputes.id || '',
  //       seller_id: allWeightDisputes.seller_id || '',
  //       waybill: allWeightDisputes.waybill || '',
  //       initial_weight: allWeightDisputes.initial_weight || '',
  //       dimension: allWeightDisputes.dimension || '',
  //       product_des: allWeightDisputes.product_des || '',
  //       sku: allWeightDisputes.sku || '',
  //       date: allWeightDisputes.date || '',
  //       reversed_weight: allWeightDisputes.reversed_weight || '',
  //       price: allWeightDisputes.price || '',
  //       status: allWeightDisputes.status || '',
  //       timestamp: allWeightDisputes.timestamp || '',
  //     });

  //     const images = JSON.parse(allWeightDisputes.image || '{}').images || [];
  //     setImageUrls(images);
  //   }
  // }, [allWeightDisputes, reset]);




  useEffect(() => {
    if (allWeightDisputes) {
      reset({
        id: allWeightDisputes.id || '',
        seller_id: allWeightDisputes.seller_id || '',
        waybill: allWeightDisputes.waybill || '',
        initial_weight: allWeightDisputes.initial_weight || '',
        dimension: allWeightDisputes.dimension || '',
        product_des: allWeightDisputes.product_des || '',
        sku: allWeightDisputes.sku || '',
        date: allWeightDisputes.date || '',
        reversed_weight: allWeightDisputes.reversed_weight || '',
        price: allWeightDisputes.price || '',
        status: allWeightDisputes.status || '',
        timestamp: allWeightDisputes.timestamp || '',
      });

      // Safe JSON parsing with error handling
      let images = [];

      if (allWeightDisputes.image) {
        try {
          const parsedImage = JSON.parse(allWeightDisputes.image);
          images = parsedImage.images || [];
        } catch (error) {

          // Optional: Try to extract partial data if JSON is truncated
          try {
            // Check if it's a truncated JSON string starting with images array
            const imageStr = allWeightDisputes.image;
            if (imageStr.includes('"images":[')) {
              // Extract the images array portion if possible
              const imagesStart = imageStr.indexOf('"images":[') + '"images":'.length;
              const imagesEnd = imageStr.lastIndexOf(']');

              if (imagesEnd > imagesStart) {
                const imagesArrayStr = imageStr.substring(imagesStart, imagesEnd + 1);
                images = JSON.parse(imagesArrayStr);
              }
            }
          } catch (fallbackError) {
            console.warn('Fallback parsing also failed:', fallbackError.message);
            images = []; // Set empty array as fallback
          }
        }
      }

      setImageUrls(images);
    }
  }, [allWeightDisputes, reset]);

  // Alternative approach: Create a utility function for safe JSON parsing
  const safeJsonParse = (jsonString, defaultValue = {}) => {
    if (!jsonString) return defaultValue;

    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.warn('JSON parsing failed:', error.message);
      return defaultValue;
    }
  };

  // Usage with the utility function:
  useEffect(() => {
    if (allWeightDisputes) {
      reset({
        id: allWeightDisputes.id || '',
        seller_id: allWeightDisputes.seller_id || '',
        waybill: allWeightDisputes.waybill || '',
        initial_weight: allWeightDisputes.initial_weight || '',
        dimension: allWeightDisputes.dimension || '',
        product_des: allWeightDisputes.product_des || '',
        sku: allWeightDisputes.sku || '',
        date: allWeightDisputes.date || '',
        reversed_weight: allWeightDisputes.reversed_weight || '',
        price: allWeightDisputes.price || '',
        status: allWeightDisputes.status || '',
        timestamp: allWeightDisputes.timestamp || '',
      });

      // Safe parsing using utility function
      const imageData = safeJsonParse(allWeightDisputes.image, { images: [] });
      const images = imageData.images || [];
      setImageUrls(images);
    }
  }, [allWeightDisputes, reset]);

  //   useEffect(() => {
  //   if (allWeightDisputes) {
  //     reset({
  //       id: allWeightDisputes.id || '',
  //       seller_id: allWeightDisputes.seller_id || '',
  //       waybill: allWeightDisputes.waybill || '',
  //       initial_weight: allWeightDisputes.initial_weight || '',
  //       dimension: allWeightDisputes.dimension || '',
  //       product_des: allWeightDisputes.product_des || '',
  //       sku: allWeightDisputes.sku || '',
  //       date: allWeightDisputes.date || '',
  //       reversed_weight: allWeightDisputes.reversed_weight || '',
  //       price: allWeightDisputes.price || '',
  //       status: allWeightDisputes.status || '',
  //       timestamp: allWeightDisputes.timestamp || '',
  //     });

  //     // Safe JSON parsing with error handling
  //     let images = [];

  //     if (allWeightDisputes.image) {
  //       try {
  //         const parsedImage = JSON.parse(allWeightDisputes.image);
  //         images = parsedImage.images || [];
  //       } catch (error) {
  //         console.warn('Failed to parse image JSON:', error.message);
  //         console.log('Raw image data:', allWeightDisputes.image);

  //         // Optional: Try to extract partial data if JSON is truncated
  //         try {
  //           // Check if it's a truncated JSON string starting with images array
  //           const imageStr = allWeightDisputes.image;
  //           if (imageStr.includes('"images":[')) {
  //             // Extract the images array portion if possible
  //             const imagesStart = imageStr.indexOf('"images":[') + '"images":'.length;
  //             const imagesEnd = imageStr.lastIndexOf(']');

  //             if (imagesEnd > imagesStart) {
  //               const imagesArrayStr = imageStr.substring(imagesStart, imagesEnd + 1);
  //               images = JSON.parse(imagesArrayStr);
  //             }
  //           }
  //         } catch (fallbackError) {
  //           console.warn('Fallback parsing also failed:', fallbackError.message);
  //           images = []; // Set empty array as fallback
  //         }
  //       }
  //     }

  //     setImageUrls(images);
  //   }
  // }, [allWeightDisputes, reset]);


  const onSubmit = (data) => {
    onClose();
  };

  const handleClose = () => {
    setIsEditMode(false);
    onClose();
  };

  const handleEyeClick = (url) => {
    const viewDocumentUrl = Url_For_View_Document + url;
    window.open(viewDocumentUrl, "_blank");
  }

  const handleEditToggle = () => {
    setIsEditMode((prev) => !prev);
  };

  return (
    <Dialog
      open={isopen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: "rounded-lg overflow-hidden"
      }}
    >
      <DialogTitle className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white relative shadow-custom-light dark:shadow-custom-dark">
        <h2 className="text-xs sm:text-xs font-bold text-white font-sans flex items-center">
          <FaWeight className="mr-3" size={16} />
          All Weight Disputes Details
        </h2>
        <IoIosCloseCircle
          className="absolute top-3 right-3 cursor-pointer hover:scale-110 transition-transform"
          size={16}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent className="bg-white dark:bg-darkmodeColor dark:text-white custom-scrollbar" style={{ maxHeight: '75vh' }}>
        <div className="p-6 bg-white dark:bg-darkmodeColor dark:text-white shadow-custom-light dark:shadow-custom-dark rounded-custom">
          <form className="space-y-8 font-sans" onSubmit={handleSubmit(onSubmit)}>

            {/* Primary Information Section */}
            <div className="bg-purple-50 dark:bg-darkmodeColor dark:text-white p-4 rounded-custom border-l-4 border-purple-500">
              <h3 className="text-lg font-bold mb-4 text-purple-700 dark:text-white flex items-center">
                <FaIdCard className="mr-2" />
                Primary Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                  <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">ID</label>
                  <input
                    type="text"
                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                    {...register('id')}
                    disabled={!isEditMode}
                  />
                  {errors.id && <p className="text-red-500 text-sm mt-1">{errors.id.message}</p>}
                </div>

                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                  <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Seller ID</label>
                  <input
                    type="text"
                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                    {...register('seller_id')}
                    disabled={!isEditMode}
                  />
                  {errors.seller_id && <p className="text-red-500 text-sm mt-1">{errors.seller_id.message}</p>}
                </div>
              </div>
            </div>

            {/* Additional Information Section */}
            <div className="bg-blue-50 dark:bg-darkmodeColor dark:text-white p-4 rounded-custom border-l-4 border-blue-500">
              <h3 className="text-lg font-bold mb-4 text-blue-700 dark:text-white flex items-center">
                <FaAddressCard className="mr-2" />
                Additional Information
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                  <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Waybill</label>
                  <input
                    type="text"
                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                    {...register('waybill')}
                    disabled={!isEditMode}
                  />
                  {errors.waybill && <p className="text-red-500 text-sm mt-1">{errors.waybill.message}</p>}
                </div>

                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                  <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Initial Weight</label>
                  <input
                    type="text"
                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                    {...register('initial_weight')}
                    disabled={!isEditMode}
                  />
                  {errors.initial_weight && <p className="text-red-500 text-sm mt-1">{errors.initial_weight.message}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                  <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Dimension</label>
                  <input
                    type="text"
                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                    {...register('dimension')}
                    disabled={!isEditMode}
                  />
                  {errors.dimension && <p className="text-red-500 text-sm mt-1">{errors.dimension.message}</p>}
                </div>

                <div className="bg-white dark:bg-darkmodeColor p-4 rounded-custom shadow-custom-light dark:shadow-custom-dark">
                  <label className="block text-sm font-bold text-gray-700 dark:text-white mb-2">Product Description</label>
                  <input
                    type="text"
                    className={`mt-1 p-3 border border-gray-300 w-full rounded-custom focus:ring-2 focus:ring-purple-500 focus:border-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white" : ""}`}
                    {...register('product_des')}
                    disabled={!isEditMode}
                  />
                  {errors.product_des && <p className="text-red-500 text-sm mt-1">{errors.product_des.message}</p>}
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div>
              <label className="block text-sm ml-2 font-bold text-black dark:text-white">
                Image For Dimension:
              </label>
              {imageUrls.map((url, index) => (
                <div key={index} className="flex items-center mt-2">
                  <input
                    type="text"
                    value={url}
                    className={`p-2 border w-full rounded-custom focus:ring-1 focus:ring-purple-500 ${isDarkMode ? "dark:bg-darkmodeColor dark:placeholder-white text-white" : ""}`}
                    disabled
                  />
                  <button
                    type="button"
                    onClick={() => handleEyeClick(url)}
                    className="ml-2 text-gray-600 dark:text-gray-400 hover:text-blue-500"
                    aria-label={`View image ${index + 1}`}
                  >
                    <FaEye size={24} />
                  </button>
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div className="flex space-x-4 mt-8">
              <button
                type="button"
                onClick={handleEditToggle}
                className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-3 px-6 rounded-custom hover:from-purple-700 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 font-medium transition-colors flex items-center dark:shadow-custom-dark shadow-custom-light"
              >
                {isEditMode ? (
                  <>
                    <FaTimes className="mr-2" /> Cancel Editing
                  </>
                ) : (
                  <>
                    <FaEdit className="mr-2" /> Edit Weight Disputes
                  </>
                )}
              </button>

              {isEditMode && (
                <button
                  type="submit"
                  className="bg-gradient-to-r from-green-500 to-green-600 text-white py-3 px-6 rounded-custom hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 font-medium transition-colors flex items-center dark:shadow-custom-dark shadow-custom-light"
                >
                  <FaSave className="mr-2" /> Save Changes
                </button>
              )}
            </div>
          </form>
        </div>
      </DialogContent>
    </Dialog>

  );
};

export default ViewWeightDisputes;
